var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"hint-btn",class:{ 'hint-btn--white': _vm.white },style:(_vm.btnStyle),attrs:{"type":"button"},on:{"click":_vm.openSidebar}},[_vm._v("?")])
}
var staticRenderFns = []

export { render, staticRenderFns }